import {isNonNullString,removeQueryString} from "$utils";

export const normalizePath = path => isNonNullString(path) && removeQueryString(path).trim().ltrim("/").rtrim("/").toLowerCase() || '';

export const normalizeSignInPath = normalizePath("/login");